import { Grid, withStyles } from '@material-ui/core';

export const MaxWidthContainer = withStyles(theme => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '1024px',
    },
  },
}))(Grid);
